<template>
  <el-container>
  <el-aside width="200px" style="background-color: #FFFFFF"><Manage></Manage></el-aside>
  <el-container>
    <el-header style="height:50px;padding: 0"><headTop></headTop></el-header>
    <el-main style="padding: 0; overflow-y: hidden"><buyTicketList></buyTicketList></el-main>
  </el-container>
</el-container>
</template>

<script>
  import buyTicketList from "@/components/buyTicketList.vue"
  import Manage from "@/components/Manage.vue"
  import headTop from "@/components/headTop.vue"
export default {
  name: "buyTicketView",
    components: {
    		buyTicketList,
    Manage,
    headTop
    	},
}
</script>

<style scoped>

</style>